import React from 'react';

const SvgSearch = props => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      d="M10.89 11.608a6.598 6.598 0 1 1 .718-.718l3.249 3.249a.5.5 0 0 1 0 .707l-.011.01a.5.5 0 0 1-.707 0l-3.249-3.248zm-.345-1.063A5.583 5.583 0 1 0 2.65 2.65a5.583 5.583 0 0 0 7.895 7.895z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgSearch;
